__webpack_require__.p = "/account/preferences/_next/";